// Header Section
export const headerSectionObj = {
  // title: 'Empower Your Financial Decisions with Intelligent Algorithms',
  title: 'Turn Smarter Insights Into Real Financial Growth',
  // subtitle: 'Committed to delivering transparency, trust and exceptional customer service',
  subtitle:
    'Compare, choose, and track the best loan rates with data-backed recommendations and full transparency',
  joinUs: 'Join Us',
  checkRates: 'Check Rates',
};

// Platform Section
const OUR_PLATFORM = 'Our Platform';

const PERSONALIZED_MATCHES = 'Personalized Matches';
// const personlized_matches_description =
//   'Our AI-driven algorithm finds your ideal match based on your unique profile.';
const personlized_matches_description =
  'AI-driven recommendations tailored to your financial goals.';

const POWERFUL_ANALYTICS = 'Powerful Analytics';
// const powerful_analytics_description =
//   'Make informed decisions with our comprehensive comparison tools.';
const powerful_analytics_description =
  'Insights that help you compare total costs and long-term impact.';

const BEST_RATES_AVAILABLE = 'Best Rates Available';
// const best_rates_available_description =
//   'We connect you with lenders and providers offering the most competitive rates in the market.';
const best_rates_available_description = 'Access competitive rates from top lenders in seconds.';

const SECURE_AND_CONFIDENTIAL = 'Secure & Confidential';
// const secure_and_confidential_description =
//   'Your information is protected with bank-level security measures.';
const secure_and_confidential_description =
  'Your information is encrypted and protected with bank-level security.';

export const platformSectionObj = {
  title: OUR_PLATFORM,
  platformContentBoxes: {
    [PERSONALIZED_MATCHES]: {
      icon: () => (
        <img
          className="platform-content-icon"
          id="imgContent"
          src="https://res.cloudinary.com/amunoali/image/upload/v1738256379/icons_5_bbsixn.png"
        />
      ),
      description: personlized_matches_description,
    },
    [POWERFUL_ANALYTICS]: {
      icon: () => (
        <img
          className="platform-content-icon"
          id="imgContent"
          src="https://res.cloudinary.com/amunoali/image/upload/v1738255978/icons_3_lv4rr9.png"
        />
      ),
      description: powerful_analytics_description,
    },
    [BEST_RATES_AVAILABLE]: {
      icon: () => (
        <img
          className="platform-content-icon"
          id="imgContent"
          src="https://res.cloudinary.com/amunoali/image/upload/v1738256292/icons_4_eky4en.png"
        />
      ),
      description: best_rates_available_description,
    },
    [SECURE_AND_CONFIDENTIAL]: {
      icon: () => (
        <img
          className="platform-content-icon"
          id="imgContent"
          src="https://res.cloudinary.com/amunoali/image/upload/v1738255978/icons_2_dofrrv.png"
        />
      ),
      description: secure_and_confidential_description,
    },
  },
};

// How CashClever Works Section
const HOW_CASHCLEVER_WORKS = 'How CashClever Works';

const enter_your_info = 'Enter Your Info';
const enter_your_info_description =
  'Provide details about your loan needs and financial situation.';

const get_matched = 'Get Matched';
// const get_matched_description = 'Our algorithm finds the best rates and terms for you.';
const get_matched_description = 'See top lender rates, matched to your profile.';

const compare_offers = 'Compare Offers';
// const compare_offers_description = 'Review and compare personalized loan offers.';
const compare_offers_description = 'Easily compare rates, terms, and savings potential.';

const apply_with_confidence = 'Apply with Confidence';
const apply_with_confidence_description =
  'Choose your preferred offer and complete your application.';

export const howCashCleverWorksObj = {
  title: HOW_CASHCLEVER_WORKS,
  HowCashCleverWorksSteps: {
    1: {
      title: enter_your_info,
      description: enter_your_info_description,
    },
    2: {
      title: get_matched,
      description: get_matched_description,
    },
    3: {
      title: compare_offers,
      description: compare_offers_description,
    },
    4: {
      title: apply_with_confidence,
      description: apply_with_confidence_description,
    },
  },
};

const empowerLendersSectionTitle = 'Empowering Lenders with Data-Driven Insights';
const empowerLendersSectionDescription =
  'Join our network of lenders and providers to access powerful analytics to make informed decisions';
const joinOurNetwork = 'Join Our Network';

// COMPARE OFFERS
export const COMPARE_YOUR_RESULTS = 'Compare Your Results';
export const LOAN_OFFER_COMPARISON = 'Loan Offer Comparison';
export const OVERALL_PAYMENT_OVER_TIME = 'Overall Payment Over Time';

const YEAR_1 = 'Year 1';
const YEAR_5 = 'Year 5';
const YEAR_10 = 'Year 10';
const YEAR_15 = 'Year 15';
const YEAR_20 = 'Year 20';
const YEAR_30 = 'Year 30';

const TRADITIONAL_BANK_1 = 'Traditional Bank 1';
const TRADITIONAL_BANK_2 = 'Traditional Bank 2';
const CASHCLEVER_MATCH = 'CashClever Match';

// types for data
export const LINE = 'line';
export const BAR = 'bar';

// OVERALL PAYMENT DATA
export const OVERALL_PAYMENT_DATA = {
  labels: [YEAR_1, YEAR_5, YEAR_10, YEAR_15, YEAR_20, YEAR_30],
  datasets: [
    {
      label: TRADITIONAL_BANK_1,
      data: [12000, 60000, 120000, 180000, 240000, 360000],
      borderColor: 'rgba(255, 99, 132, 1)',
      backgroundColor: 'rgba(255, 99, 132, .5)',
      fill: false,
    },
    {
      label: TRADITIONAL_BANK_2,
      data: [23000, 75000, 165000, 210000, 285000, 397000],
      borderColor: 'rgba(240, 130, 85, 1)',
      backgroundColor: 'rgba(240, 130, 85, .5)',
      fill: false,
    },
    {
      label: CASHCLEVER_MATCH,
      data: [10000, 52000, 103000, 135000, 210000, 310000],
      borderColor: 'rgba(54, 162, 235, 1)',
      backgroundColor: 'rgba(54, 162, 235, .5)',
      fill: true,
    },
  ],
};

const TOTAL_AMOUNT_PAID_OVER_TIME = 'Total Amount Paid Over Time';
const TOTAL_AMT_PAID = 'Total Amount Paid ($)';

// OVERALL PAYMENT OPTIONS
export const OVERALL_PAYMENT_OPTIONS = {
  responsive: true,
  plugins: {
    title: {
      display: true,
      text: TOTAL_AMOUNT_PAID_OVER_TIME,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      title: {
        display: true,
        text: TOTAL_AMT_PAID,
      },
    },
  },
};

const LENDER_A = 'Lender A';
const LENDER_B = 'Lender B';
const LENDER_C = 'Lender C';
const CASHCLEVER_BEST_OFFER = 'Best Offer';

const INTEREST_RATE = 'Interest Rate';

// INTEREST RATE COMPARISON DATA
export const INTEREST_RATE_COMPARISON_DATA = {
  labels: [LENDER_A, LENDER_B, LENDER_C, CASHCLEVER_BEST_OFFER],
  datasets: [
    {
      label: INTEREST_RATE,
      data: [4.5, 4.3, 4.1, 3.8],
      backgroundColor: [
        'rgba(255, 99, 132, .7)',
        'rgba(54, 162, 235, .7)',
        'rgba(255, 206, 86, .7)',
        'rgba(75, 192, 192, .7)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
      ],
      borderWidth: 1,
    },
  ],
};

const INTEREST_RATE_COMPARISON = 'Interest Rate Comparison';
const INTEREST_RATE_PERCENT = 'Interest Rate (%)';

export const INTEREST_RATE_COMPARISON_OPTIONS = {
  responsive: true,
  plugins: {
    title: {
      display: true,
      text: INTEREST_RATE_COMPARISON,
    },
    legend: {
      display: false,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      title: {
        display: true,
        text: INTEREST_RATE_PERCENT,
      },
    },
  },
};

const MARKET_TRENDS = 'Market Trends';
const RISK_ASSESSMENT = 'Risk Assessment';

const PRODUCT_OPTIMIZATION = 'Product Optimization';
const PERFORMANCE_METRICS = 'Performance Metrics';

export const empoweringLendersSectionObj = {
  title: empowerLendersSectionTitle,
  description: empowerLendersSectionDescription,
  empoweringLendersContentSection: {
    [MARKET_TRENDS]: {
      BOX_CONTENT_CLASSNAME: 'partner-insights-box-content-market-trends',
      icon: () => (
        <img
          className="platform-content-icon"
          id="imgContent"
          src="https://res.cloudinary.com/amunoali/image/upload/v1738256782/icons_9_hiigzx.png"
        />
      ),
      description: 'Stay ahead with real-time market analysis and emerging lending patterns',
    },
    [RISK_ASSESSMENT]: {
      BOX_CONTENT_CLASSNAME: 'partner-insights-box-content-risk-assessment',
      icon: () => (
        <img
          className="platform-content-icon"
          id="imgContent"
          src="https://res.cloudinary.com/amunoali/image/upload/v1738287053/icons_14_mumvfi.png"
        />
      ),
      description: 'Enhance your risk models with aggregated, anonymous data insights',
    },
    [PRODUCT_OPTIMIZATION]: {
      BOX_CONTENT_CLASSNAME: 'partner-insights-box-content-product-optimization',
      icon: () => (
        <img
          className="platform-content-icon"
          id="imgContent"
          src="https://res.cloudinary.com/amunoali/image/upload/v1738257331/icons_13_rr1zcf.png"
        />
      ),
      description: 'Refine your loan products based on consumer preferences and behavior',
    },
    [PERFORMANCE_METRICS]: {
      BOX_CONTENT_CLASSNAME: 'partner-insights-box-content-performance-metrics',
      icon: () => (
        <img
          className="platform-content-icon"
          id="imgContent"
          src="https://res.cloudinary.com/amunoali/image/upload/v1738257334/icons_12_oyumnj.png"
        />
      ),
      description: 'Track your lending performance against industry benchmarks',
    },
  },
  linkText: joinOurNetwork,
};

// WHO WE ARE
export const WHO_WE_ARE = 'Who We Are';

export const OUR_STORY = 'Our Story';
export const OUR_STORY_DESCRIPTION =
  'Millions of consumers overpay for financing and insurance every year leaving families struggling to make ends meet.';

export const OUR_VISION = 'Our Vision';
export const OUR_VISION_DESCRIPTION =
  "By putting money back in the hands of consumers, we don't just create more individual wealth but also a stronger economy.";

export const OUR_TECHNOLOGY = 'Our Technology';
export const OUR_TECHNOLOGY_DESCRIPTION =
  'With cutting-edge algorithms, we enable consumers to make data-driven decisions and unlock insights that were previously unavailable';
